import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../modules/infra/i18n';
import Queue from '../../queue/QueueContainer';
import config from '../../../config';

const ExportableReport = ({
  canLoadReport,
  name,
  label,
  children,
  startDate,
  endDate,
  additionalFilters,
  exportReportDays,
}) => {
  if (canLoadReport) {
    return (
      <div>{children}</div>
    );
  }

  return (
    <div className="u-text-center">
      <h4>{t('reports:export_large_range', { exportReportDays })}</h4>
      <Queue
        name="reports"
        btnLabel={t('reports:export_csv')}
        btnClass="c-btn u-mt"
        jobName={name}
        label={label}
        filters={{
          startDate,
          endDate,
          ...additionalFilters,
        }}
      />
    </div>
  );
};

ExportableReport.propTypes = {
  canLoadReport: PropTypes.bool.isRequired,
  additionalFilters: PropTypes.object,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  exportReportDays: PropTypes.number,
};

ExportableReport.defaultProps = {
  additionalFilters: {},
  exportReportDays: config.exportReportDays,
};

const mapStateToProps = state => ({
  startDate: state.reports.startDate,
  endDate: state.reports.endDate,
});

export default connect(mapStateToProps)(ExportableReport);
